// types
import { ToggleButtonFilterProps } from '../components/ag-table/types';
import { SearchableSelectType } from '../components/inputs/searchableSelect';

// theme
import aampeTheme from '../constants/aampeTheme';

export enum EventContext {
    positive = 'positive',
    ignore = 'ignore',
    negative = 'negative',
}
export interface EventModel {
    id: number;
    code: string;
    name: string;
    is_goal: boolean;
    stats: EventStatsModel;
    trend: TrendType;
    is_imported: boolean;
    event_type: EventType;
    attached_triggers_count: number;
    status?: EventStatus;
    weekly_stats: WeeklyStatsModel;
    context?: EventContext | null;
}

export interface EventStatsModel {
    average_events_per_contact: number;
    centrality: number;
    cluster_order: number;
    clustering_high: number;
    clustering_low: number;
    clustering_mid: number;
    event_name: string;
    n_contacts: number;
    n_events: number;
}
export interface WeeklyStatsModel {
    n_contacts: number;
    n_events: number;
}

export enum TrendType {
    Up = 'up',
    Down = 'down',
}

export interface FormulaEventTriggerModel {
    id: number;
    formula_id: number;
    contact_event: EventModel;
}

export enum EventTriggerType {
    General = 'General',
    Triggered = 'Triggered',
}

export enum EventStatus {
    Imported = 'Imported',
    Blocked = 'Ignored',
    Reserved = 'Reserved',
}
export enum EventFrequency {
    MONTH = 'last_month',
    WEEK = 'last_week',
}

export interface EventLiteModel {
    id: number;
    name: string;
}

export enum EventType {
    MessageClick = 'Message click',
    IntentSignal = 'Intent signal',
    Conversion = 'Conversion',
    AppVisited = 'App visited',
}

export interface EventConfigUpdateModel {
    event_type: EventType;
    display_name?: string;
    custom_icon_id?: string;
}

export interface CustomEventIcon {
    url: string;
    id: string;
}
export interface EventTypeWithCustomIcon {
    display_name: string;
    custom_icon: CustomEventIcon;
}

export type EventTypeConfigModel = {
    [key in EventType]: EventTypeWithCustomIcon;
} & {
    [key: string]: EventTypeWithCustomIcon;
};

export type EventConfigureFormValues = {
    [key in EventType]: {
        display_name: string;
        custom_icon: SearchableSelectType;
    };
};

export interface EventTypesConfigModel {
    event_types: EventTypeConfigModel;
}

export interface EventUpdateModel {
    eventId: number;
    eventData: {
        is_imported?: boolean;
        event_type?: EventType;
        context?: EventContext;
    };
}
export interface EventBulkUpdateModel {
    id: number;
    context: EventContext;
}
export interface EventTypesDataModel {
    description: string;
    example?: string;
    backgroundColor?: string;
}

export const eventTypesData: { [key in EventType]: EventTypesDataModel } = {
    [EventType.MessageClick]: {
        description: 'Events that indicate if a message was viewed or cliked.',
        example: 'Examples: notification clicked, deeplink clicked, etc',
        backgroundColor: aampeTheme.colors.primary25,
    },
    [EventType.AppVisited]: {
        description:
            'This includes all app events that you import and is used to measure any activity in your app.',
        backgroundColor: aampeTheme.colors.primary100,
    },
    [EventType.IntentSignal]: {
        description:
            'Events that indicate user intent to purchase, but are not an actual conversion.',
        example: 'Examples: item added to cart, item added to wishlist, etc',

        backgroundColor: aampeTheme.colors.interactiveA01,
    },
    [EventType.Conversion]: {
        description: 'Events that indicate new revenue for your business.',

        example: 'Examples: checkout completed, subscription purchased, etc',
        backgroundColor: aampeTheme.colors.primary300,
    },
};

export interface EventTypeStatData {
    total_events: number;
    monthly_volume: number;
    weekly_volume: number;
}

export type EventTypeStatsModel = {
    [key in EventType]: EventTypeStatData;
};

export enum FunnelVolumeTimeWindow {
    MONTHLY = 'monthly_volume',
    WEEKLY = 'weekly_volume',
}

export const EVENT_STATUS_OPTIONS: SearchableSelectType[] = [
    { value: EventStatus.Imported, label: 'Imported' },
    { value: EventStatus.Blocked, label: 'Ignored' },
    { value: EventStatus.Reserved, label: 'Reserved' },
];

export const EVENT_DATE_RANGE_OPTIONS: ToggleButtonFilterProps[] = [
    {
        value: EventFrequency.MONTH,
        label: 'Last month',
        isLeft: true,
    },
    {
        value: EventFrequency.WEEK,
        label: 'Last week',
        isRight: true,
    },
];
